import { CANCEL_ORDER_FAILURE, CANCEL_ORDER_REQUEST, CANCEL_ORDER_SUCCESS } from "../../actions";
const initialState = {
    data: null,
    result: null,
    loading: false,
    error: null,
};
const cancelOrderData = (state = initialState, action) => {
    switch (action.type) {
        case CANCEL_ORDER_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, result: action.payload });
        case CANCEL_ORDER_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: action.payload, error: null });
        case CANCEL_ORDER_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload, data: null });
        default:
            return state;
    }
};
export default cancelOrderData;
